import { Box, Grid } from "@mui/material"
import { useQuery } from "@tanstack/react-query"
import { useNavigate, useParams } from "react-router-dom"
import giftApis from "src/api/gifts"
import { NA } from "src/constants/common"
import { ORDER_BY_CODE } from "src/constants/queryKeys"
import { theme } from "src/providers/ThemeProvider"
import { Dialog, Text } from "src/shared"
import { formatNumber } from "src/utils/formatNumber"

const OrderDetails = () => {
  const { orderCode } = useParams()
  const navigate = useNavigate()
  const onGoBack = () => navigate("/")

  const { data } = useQuery({
    queryKey: [ORDER_BY_CODE],
    queryFn: () => giftApis.getGiftOrderByCode(orderCode || ""),
    enabled: !!orderCode,
  })

  return (
    <Dialog
      sx={{
        paddingBottom: 2,
      }}
      open
      onClose={onGoBack}
    >
      <Grid
        justifyContent="center"
        alignItems="center"
        rowGap={1}
        container
        flexDirection="column"
      >
        <Text
          color={data ? theme.palette.secondary.main : theme.palette.error.main}
          fontSize={24}
          lineHeight="31.65px"
          fontWeight={700}
          textAlign="center"
        >
          {data
            ? "Chúc mừng bạn đã nhận được phần quà"
            : "Không tìm thấy quà tặng!"}
        </Text>
        {data && (
          <>
            <Box
              sx={{
                [theme.breakpoints.down(400)]: {
                  width: 180,
                  height: 150,
                },
              }}
              width={260}
              height={200}
            >
              <img
                width="100%"
                height="100%"
                src={`${process.env.REACT_APP_IMAGE_URL}${data?.ProductDefaultImage}`}
                alt="gift-success"
              />
            </Box>
            <Box>
              <Text fontSize={16} textAlign="center">
                {data?.ProductName || NA}
              </Text>
              <Text fontSize={16} textAlign="center">
                Trị giá <b>{formatNumber(data?.OrderValue || 0)}đ</b>
              </Text>
            </Box>
          </>
        )}
      </Grid>
    </Dialog>
  )
}

export default OrderDetails
